export default {
    ZENDESK: {
        SDK_URL: 'https://dev.zopim.com/web-sdk/latest/web-sdk.js',
        INVALID_AUTH_KEY_STATUS: ['invalid_account_key', 'banned'],
        EVENT_TYPES: {
            CONNECTION_UPDATE: 'connection_update',
            AGENT_UPDATE: 'agent_update',
            CHAT: 'chat',
            MEMBER_LEAVE: 'chat.memberleave',
            MEMBER_JOIN: 'chat.memberjoin',
            MEMBER_FEEDBACK_REQUEST: 'chat.request.rating',
            QUEUE_POSITION: 'chat.queue_position',
            MESSAGE: 'chat.msg',
            FILE: 'chat.file',
            TYPING: 'typing'
        },
        CONNECTION_STATUS: {
            CONNECTED: 'connected',
            CLOSED: 'closed',
            CONNECTING: 'connecting'
        },
        ERROR_EVENTS: {
            SET_VISITOR_INFO: 'setVisitorInfo'
        },
        VISITOR_NICK: 'visitor',
        AGENT_AVAILABILITY_TIMEOUT: 2147483647,
        WITHIN_OPERATING_HOURS_DEPARTMENT_STATUS: ['online'],
        OUTSIDE_OPERATING_HOURS_DEPARTMENT_STATUS: [],
        OFFLINE_TIMEOUT: 30000
    },
    GENERIC_AGENTDESK: {
        EVENT_INFO: {
            EVENT_TYPE: 'Agent.Event.Type',
            AGENT_NAME: 'Agent.Name',
            AGENT_AVATAR_URL: 'Agent.Avatar.Url',
            QUEUE_POSITION: 'QueuePosition'
        },
        EVENTS: {
            AGENT_JOIN: 'join',
            AGENT_LEAVE: 'leave',
            AGENT_TRANSFER: 'transfer',
            WAITING: 'waiting',
            TYPING_INDICATOR: 'typing'
        },
        EVENT_MESSAGE: {
            QUEUE_POSITION: (queue_position) => `Queue Position: ${queue_position}`
        }
    },
    EVENT_SUB_TYPES: {
        AGENT_JOIN: 'JOIN',
        AGENT_JOIN_CONFERENCE: 'AGENT_JOIN_CONFERENCE',
        AGENT_LEFT_CONFERENCE: 'AGENT_LEFT_CONFERENCE',
        AGENT_LEAVE: 'LEAVE',
        AGENT_TRANSFER: 'TRANSFER',
        AGENT_TRANSFER_AND_JOIN: 'TRANSFER_AND_JOIN',
        WAIT: 'WAIT',
        GENERIC_INFO: 'GENERIC_INFO',
        REVIEW:'REVIEW',
        TYPING_INDICATOR: 'TYPING',
        AGENTDESK_CONFIGURATION_NOT_FOUND: 'AGENTDESK_CONFIGURATION_NOT_FOUND',
        CONFIG: 'CONFIG'
    },
    SCRIPT_TAG_ID: 'agentDeskSDK',
    AGENT_DESK_CHATS_STORAGE_KEY: 'agentDeskChats',
    AGENT_INFO: 'agentInfo',
    TALK_TO_AGENT_UTTERANCE: 'talk to agent',
    BACK_TO_BOT_UTTERANCE: 'back to bot',
    SEND_BACK_TO_BOT_DELAY: 10,
    DEPARTMENT_HANDOFF_FAILED_CODES: {
        OUT_OF_OPERATING_HOURS: 'OUT_OF_OPERATING_HOURS',
        NO_AGENT_AVAILABLE: 'NO_AGENT_AVAILABLE',
        ALL_AGENTS_OCCUPIED: 'ALL_AGENTS_OCCUPIED'
    },
    TRANSCRIPT_RELATED_INFO_KEY: 'transcriptRelatedInfo'
}
